import { Component, HostListener, OnInit } from '@angular/core';
import { UserService } from '../../shared/services/user.service';

@Component({
  selector: 'app-our-story',
  templateUrl: './our-story.component.html',
  styleUrls: ['./our-story.component.scss']
})
export class OurStoryComponent implements OnInit {
  // whycs_header: string = '4rem';
  
  // Scrolling banner data
  scrollContent: any[] = [];
  
  constructor(public userService: UserService) { }

  ngOnInit(): void {
    this.adjustRightValue();
    window.scrollTo(0, 0);
    this.createScrollContent();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event): void {
    this.adjustRightValue();
  }

  adjustRightValue(): void {
    // Check if the screen width is greater than 1200px
    // if (window.innerWidth > 1200) {
    //   this.whycs_header = '15rem';
    // } else {
    //   this.whycs_header = '-26rem';
    // }
  }

  createScrollContent(): void {
    const phrases = [
      "Joy Becomes Strategy",
      "Wellness Becomes Wealth", 
      "Fun Fuels Movement",
      "Rise and Glow",
      "Juice Life",
      "Bold Souls Rising",
      "Sacred Experience",
      "Expansive Commerce",
      "Blue-Ocean Leap",
      "Compassionate Capitalism"
    ];
    
    this.scrollContent = [];
    for (let i = 0; i < 6; i++) { // Repeat 6 times to ensure no gaps
      phrases.forEach((phrase, index) => {
        this.scrollContent.push({
          phrase: phrase,
          key: `scroll-${i}-${index}`
        });
      });
    }
  }

  isLoggedIn() {
    if (
      Object.keys(this.userService.userServiceModal.customerData).length &&
      this.userService.userServiceModal.customerData.CustomerId &&
      this.userService.checkIfUserAuthenticatedOrNot()
    ) {
      return true;
    } else {
      return false;
    }
  }
}
